var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "../_snowpack/pkg/react.js";

function SvgIconSearchMessenger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 19H3c-.6 0-1-.4-1-1v-2h13V7h4.7c1.1 0 1.6.6 1.9 1.1.6.9 1.5 2.4 2.1 3.4.2.3.3.7.3 1V17c0 1.1-.7 2-2 2h-1c0 1.7-1.3 3-3 3s-3-1.3-3-3h-5c0 1.7-1.3 3-3 3s-3-1.3-3-3zm3-1.2c.7 0 1.2.5 1.2 1.2s-.5 1.2-1.2 1.2-1.2-.5-1.2-1.2.5-1.2 1.2-1.2zm11 0c.7 0 1.2.5 1.2 1.2s-.5 1.2-1.2 1.2-1.2-.5-1.2-1.2.5-1.2 1.2-1.2zM2 11.7c-1.2-1-2-2.5-2-4.2C0 4.5 2.5 2 5.5 2c1.7 0 3.2.8 4.2 2H13c.6 0 1 .4 1 1v10H2v-3.3zM17 9v3h4.7l-1.4-2.5c-.2-.3-.5-.5-.9-.5H17zM5.5 4C7.4 4 9 5.6 9 7.5S7.4 11 5.5 11 2 9.4 2 7.5 3.6 4 5.5 4zM6 7h2v1H5V5h1v2z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })));
}

export default SvgIconSearchMessenger;